class Buttons {
	constructor() {
		const svg = `<svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.0781684 5.51223H5.86408C5.89596 5.51253 5.9245 5.53326 5.9365 5.56479C5.94857 5.59633 5.94166 5.63249 5.91906 5.65658L2.86357 8.85668C2.8402 8.88076 2.8333 8.91782 2.8462 8.94973C2.85911 8.98156 2.88911 9.00155 2.92155 8.99991L5.78397 8.91543C5.80434 8.91528 5.8238 8.90641 5.83796 8.89083L9.97558 4.57376C9.99121 4.55765 10 4.53551 10 4.51232C10 4.48914 9.99121 4.46699 9.97558 4.45088L5.85993 0.0246403C5.84416 0.00823739 5.82289 -0.000634583 5.80091 3.53659e-05L3.1905 0.0481247C3.15903 0.0487958 3.13099 0.0694488 3.11906 0.100539C3.10713 0.13163 3.11362 0.167269 3.13545 0.191425L5.90089 3.23444C5.92308 3.2583 5.9297 3.29402 5.9177 3.32511C5.9057 3.3562 5.87738 3.37648 5.84592 3.37663H0.17002C0.142951 3.3761 0.115883 3.37394 0.0890213 3.37021C0.0666963 3.36678 0.0440231 3.37394 0.026999 3.38967C0.00990645 3.40548 6.96538e-05 3.42837 0 3.45253V5.42878C0 5.45093 0.00823245 5.4721 0.0228823 5.48776C0.0374633 5.50334 0.0575187 5.51223 0.0781684 5.51223Z" fill="currentColor"/>
</svg>
`;

		const btnBack = document.querySelectorAll('.btn--back');

		btnBack.forEach((btn) => {
			btn.insertAdjacentHTML('afterbegin', svg);
		});

		const btnGo = document.querySelectorAll('.btn--go');
		btnGo.forEach((btn) => {
			btn.insertAdjacentHTML('beforeend', svg);
		});
	}
}
